export default "__VITE_ASSET__9VtyURcz__"